import { render, staticRenderFns } from "./GridChatWindowContact.vue?vue&type=template&id=38a295cb&scoped=true"
import script from "./GridChatWindowContact.vue?vue&type=script&lang=js"
export * from "./GridChatWindowContact.vue?vue&type=script&lang=js"
import style0 from "./GridChatWindowContact.vue?vue&type=style&index=0&id=38a295cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a295cb",
  null
  
)

export default component.exports